function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function elementIsVisible(element) {
	var position = element.getBoundingClientRect();
  var position_bottom = position.bottom;
  if (element.offsetHeight >= window.innerHeight) {
    position_bottom = position.bottom - 500;
  }
	if(position.top >= 0 && position_bottom <= window.innerHeight) {
		return true;
	}
}

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "{{amount}}€";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ' ');
    decimal   = defaultOption(decimal, ',');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'money_without_currency':
      value = formatWithDelimiters(cents, 2, '.', '.');
      break;
  }

  return value;
};

Shopify.money_format_number = "{{amount}}";
Shopify.formatMoneyNumber = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format_number);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ' ');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', '.');
      break;
    case 'money_without_currency':
      value = formatWithDelimiters(cents, 2, '.', '.');
      break;
  }

  return parseFloat(formatString.replace(placeholderRegex, value));
};

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}




// class QuantityInput extends HTMLElement {
//   constructor() {
//     super();
//     this.input = this.querySelector('input');
//     this.changeEvent = new Event('change', { bubbles: true })

//     this.querySelectorAll('button').forEach(
//       (button) => button.addEventListener('click', this.onButtonClick.bind(this))
//     );
//   }

//   onButtonClick(event) {
//     event.preventDefault();
//     const previousValue = this.input.value;

//     event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
//     if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
//   }
// }

// customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    document.querySelector('.product-media-modal').addEventListener(
      'click',
      this.hide.bind(this, true),
    );
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false),
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);

    this.selling_plan_id = null;

    this.checkbox = document.getElementById('subscriptionCheck');
    if (this.checkbox != null) {
      
      if (this.checkbox) {
        const triggerChange = () => {
          this.onVariantChange();
        };
        this.checkbox.addEventListener('click', triggerChange);
      }
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateTags();
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.updateShareUrl();
      this.updateMonthSubscription();
      this.updatePricePerMonth();
      this.updateSubscriptionPrice();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateSubscriptionPrice() {
    const subscriptionValue = document.querySelector('.subscription-button').getAttribute('data-subscription-value');
    const subscriptionPrice = document.querySelector(".subscription-price");
    const newSubscriptionPrice =  this.currentVariant.price - (subscriptionValue / 100 * this.currentVariant.price);
    subscriptionPrice.innerHTML =  '<b>' + Shopify.formatMoney(newSubscriptionPrice, 'amount_with_comma_separator') + '€</b>';
  }

  updateMonthSubscription() {
    console.log(this.currentVariant);
    const valueMonth = this.currentVariant.title[0];
    const valueOnChange = document.querySelector('#frequency_value');
    if (valueOnChange) {
      valueOnChange.innerHTML = valueMonth;
    }
  }

  setSellingPlan() {

    if (this.checkbox.checked){
      const valueSellingPlan = this.currentVariant.selling_plan_allocations[0].selling_plan_id;
      this.selling_plan_id = valueSellingPlan;
      updateCheckboxVisual();
    } else {
      this.selling_plan_id = null;
      updateCheckboxVisual();
    }
  }

  getSellingPlan() {
    return this.selling_plan_id;
  }

  updatePricePerMonth() {
    const target = document.querySelector('.product__info-container .price-per-days');
    if (target){
      let pricePerMonth = this.currentVariant.price;
      const checkbox = document.getElementById('subscriptionCheck');
      const subscriptionValue = document.querySelector('.subscription-button').getAttribute('data-subscription-value');
      if (checkbox.checked){
        pricePerMonth = this.currentVariant.price - (subscriptionValue / 100 * this.currentVariant.price);
      }
      if (this.currentVariant.option1.includes('1')) {
        pricePerMonth = pricePerMonth / 30;
      }else if (this.currentVariant.option1.includes('3')) {
        pricePerMonth = pricePerMonth / 90;
      }else if (this.currentVariant.option1.includes('6')) {
        pricePerMonth = pricePerMonth / 180;
      };
      
      target.innerHTML = Shopify.formatMoney(pricePerMonth, 'amount_with_comma_separator');
    }
  }

  updateTags() {
    const tagDatas = document.querySelector('product-form .btn--add-to-cart');
    if (tagDatas && this.currentVariant) {
      const tagDataDiscount = this.currentVariant.compare_at_price - this.currentVariant.price;
      if (this.currentVariant.id) {
        tagDatas.setAttribute('data-item_barcode', this.currentVariant.id);
      }
      if (this.currentVariant.price) {
        tagDatas.setAttribute('data-price', Shopify.formatMoney(this.currentVariant.price, 'money_without_currency'));
        // priceData.setAttribute('data-regular-price', Shopify.formatMoney(this.currentVariant.price, 'money_without_currency'));
      }
      if (this.currentVariant.compare_at_price) {
        tagDatas.setAttribute('data-discount', Shopify.formatMoney(tagDataDiscount, 'money_without_currency'));
      } else {
        tagDatas.setAttribute('data-discount', 0);
      }
      if (this.currentVariant.barcode) {
        tagDatas.setAttribute('data-item_id', this.currentVariant.barcode);
      }
      if (this.currentVariant.name) {
        tagDatas.setAttribute('data-item_name', this.currentVariant.name);
      }
    }
    console.log(this.currentVariant);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    this.setSellingPlan();
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      const checkbox = document.getElementById('subscriptionCheck');
      const subscriptionValue = document.querySelector('.subscription-button').getAttribute('data-subscription-value');
      const isPreOrder = document.querySelector('input[name="properties[_preco]"]');
      addButton.removeAttribute('disabled');
      if (checkbox.checked){
        if (isPreOrder){
          addButtonText.textContent = window.variantStrings.preOrder + ' | ' + Shopify.formatMoney(this.currentVariant.price - (subscriptionValue / 100 * this.currentVariant.price), 'amount_with_comma_separator') + ' €';
        } else {
          addButtonText.textContent = window.variantStrings.addToCart + ' | ' + Shopify.formatMoney(this.currentVariant.price - (subscriptionValue / 100 * this.currentVariant.price), 'amount_with_comma_separator') + ' €';
        }
      }else{
        if (isPreOrder){
          addButtonText.textContent = window.variantStrings.preOrder + ' | ' + Shopify.formatMoney(this.currentVariant.price, 'amount_with_comma_separator') + ' €';
        } else {
          addButtonText.textContent = window.variantStrings.addToCart + ' | ' + Shopify.formatMoney(this.currentVariant.price, 'amount_with_comma_separator') + ' €';
        }
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

window.addEventListener('DOMContentLoaded', () => {
  var viewItemList = document.querySelectorAll('[data-gtm-view-item-list]');
  if (viewItemList.length > 0) {
    for (let index = 0; index < viewItemList.length; index++) {
      const element = viewItemList[index];
      window.addEventListener('scroll', function() {
        var sectionIsViewed = element.dataset.gtmViewItemListViewed;

        if (sectionIsViewed == 'false' && elementIsVisible(element)) {
          element.setAttribute('data-gtm-view-item-list-viewed', 'true');
          var dataEvent = JSON.parse(element.dataset.gtmViewItemList);
          var evt = new CustomEvent("gtmViewItemList", {'detail': dataEvent});
          window.dispatchEvent(evt);
        }
      }); 
    } 
  }

  var viewItemList = document.querySelectorAll('[data-gtm-view-item-list-search]');
  if (viewItemList.length > 0) {
    for (let index = 0; index < viewItemList.length; index++) {
      const element = viewItemList[index];
      var dataEvent = JSON.parse(element.dataset.gtmViewItemListSearch);
      var evt = new CustomEvent("gtmViewItemList", {'detail': dataEvent});
      window.dispatchEvent(evt);
    } 
  }
  var viewItemList = document.querySelectorAll('[data-gtm-view-item-list-essentiels]');
  if (viewItemList.length > 0) {
    for (let index = 0; index < viewItemList.length; index++) {
      const element = viewItemList[index];
      var dataEvent = JSON.parse(element.dataset.gtmViewItemListEssentiels);
      var evt = new CustomEvent("gtmViewItemList", {'detail': dataEvent});
      window.dispatchEvent(evt);
    } 
  }

  var clickItem = document.querySelectorAll('[data-gtm-select-item]');
  if (clickItem.length > 0) {
    for (let index = 0; index < clickItem.length; index++) {
      const element = clickItem[index];
      element.addEventListener('click', function(e) {
        e.preventDefault();
        var dataEvent = JSON.parse(element.dataset.gtmSelectItem);
        var evt = new CustomEvent("gtmViewSelectList", {'detail': dataEvent});
        window.dispatchEvent(evt);        
        setTimeout(function(){location.href = element.getAttribute("href")}, 1000);
      });
    }
  }

  var logouts = document.querySelectorAll('[data-gtm-logout]');
  if (logouts.length > 0) {
    for (let index = 0; index < logouts.length; index++) {
      const element = logouts[index];
      element.addEventListener('click', function(e) {
        e.preventDefault();
        var dataEvent = {};
        var evt = new CustomEvent("gtmLogout", {'detail': dataEvent});
        window.dispatchEvent(evt);        
        setTimeout(function(){location.href = element.getAttribute("href")}, 2000);
      });
    }
  }

  var languageLinks = document.querySelectorAll('[data-gtm-language-link]');
  if (languageLinks.length > 0) {
    for (let index = 0; index < languageLinks.length; index++) {
      const element = languageLinks[index];
      element.addEventListener('click', function(e) {
        e.preventDefault();
        var dataEvent = {
          "position": e.target.getAttribute('data-gtm-language-link'),
          "country_status": langify.locale.iso_code + '_to_' + e.target.querySelector('.header--mobile__language-iso').innerHTML.toLowerCase()
        };
        var evt = new CustomEvent("gtmLanguageLinks", {'detail': dataEvent});
        window.dispatchEvent(evt);        
        setTimeout(function(){location.href = element.getAttribute("href")}, 1000);
      });
    }
  }

  var contactPhone = document.querySelectorAll('[data-gtm-contact-phone]');
  if (contactPhone.length > 0) {
    for (let index = 0; index < contactPhone.length; index++) {
      const element = contactPhone[index];
      element.addEventListener('click', function(e) {
        e.preventDefault();
        var dataEvent = {};
        var evt = new CustomEvent("gtmContactPhone", {'detail': dataEvent});
        window.dispatchEvent(evt);        
        setTimeout(function(){location.href = element.getAttribute("href")}, 1000);
      });
    }
  }

  var contactMail = document.querySelectorAll('[data-gtm-contact-mail]');
  if (contactMail.length > 0) {
    for (let index = 0; index < contactMail.length; index++) {
      const element = contactMail[index];
      element.addEventListener('click', function(e) {
        e.preventDefault();
        var dataEvent = {};
        var evt = new CustomEvent("gtmContactMail", {'detail': dataEvent});
        window.dispatchEvent(evt);        
        setTimeout(function(){location.href = element.getAttribute("href")}, 1000);
      });
    }
  }

  var socialLinks = document.querySelectorAll('[data-gtm-click-social]');
  if (socialLinks.length > 0) {
    for (let index = 0; index < socialLinks.length; index++) {
      const element = socialLinks[index];
      element.addEventListener('click', function(e) {
        e.preventDefault();
        var dataEvent = {
          "social": e.target.getAttribute('data-gtm-click-social')
        };
        var evt = new CustomEvent("gtmSocialLinks", {'detail': dataEvent});
        window.dispatchEvent(evt);        
        setTimeout(function(){location.href = element.getAttribute("href")}, 1000);
      });
    }
  }

  var packLinks = document.querySelectorAll('[data-gtm-click-pack]');
  if (packLinks.length > 0) {
    for (let index = 0; index < packLinks.length; index++) {
      const element = packLinks[index];
      element.addEventListener('click', function(e) {
        e.preventDefault();
        var dataEvent = {
          "cta_title": e.target.innerText
        };
        var evt = new CustomEvent("gtmPackLinks", {'detail': dataEvent});
        window.dispatchEvent(evt);        
        setTimeout(function(){location.href = element.getAttribute("href")}, 1000);
      });
    }
  }

  var sliderLinks = document.querySelectorAll('[data-gtm-click-slider]');
  if (sliderLinks.length > 0) {
    for (let index = 0; index < sliderLinks.length; index++) {
      const element = sliderLinks[index];
      element.addEventListener('click', function(e) {
        e.preventDefault();
        var dataEvent = {
          "banner_name": e.target.getAttribute('data-gtm-click-slider'),
          "cta_title": e.target.innerText
        };
        var evt = new CustomEvent("gtmCtaSlider", {'detail': dataEvent});
        window.dispatchEvent(evt);        
        setTimeout(function(){location.href = element.getAttribute("href")}, 1000);
      });
    }
  }

  var sliderDots = document.querySelectorAll('[data-gtm-click-slider-dot]');
  if (sliderDots.length > 0) {
    for (let index = 0; index < sliderDots.length; index++) {
      const element = sliderDots[index];
      element.addEventListener('click', function(e) {
        e.preventDefault();
        var dataEvent = {
          "banner_name": e.target.getAttribute('data-gtm-click-slider-dot'),
          "index": e.target.getAttribute('data-gtm-click-slider-dot-index'),
        };
        var evt = new CustomEvent("gtmSliderDot", {'detail': dataEvent});
        window.dispatchEvent(evt);
      });
    }
  }  
  
  var linksFooter = document.querySelectorAll('[data-gtm-click-link-footer]');
  if (linksFooter.length > 0) {
    for (let index = 0; index < linksFooter.length; index++) {
      const element = linksFooter[index];
      element.addEventListener('click', function(e) {
        e.preventDefault();
        var dataEvent = {
          "footer_menu": e.target.getAttribute('data-gtm-click-link-footer'),
        };
        var evt = new CustomEvent("gtmLinksFooter", {'detail': dataEvent});
        window.dispatchEvent(evt);
        setTimeout(function(){location.href = element.getAttribute("href")}, 1000);
      });
    }
  }
  
  var linksMegaMenu = document.querySelectorAll('[data-gtm-click-link-mega-menu]');
  if (linksMegaMenu.length > 0) {
    for (let index = 0; index < linksMegaMenu.length; index++) {
      const element = linksMegaMenu[index];
      element.addEventListener('click', function(e) {
        e.preventDefault();
        var dataEvent = {
          "menu_level1": e.target.getAttribute('data-gtm-click-link-mega-menu'),
          "menu_level2": e.target.innerText
        };
        var evt = new CustomEvent("gtmLinksMegaMenu", {'detail': dataEvent});
        window.dispatchEvent(evt);
        setTimeout(function(){location.href = element.getAttribute("href")}, 1000);
      });
    }
  }  

  var linksHeader = document.querySelectorAll('[data-gtm-click-link-header]');
  if (linksHeader.length > 0) {
    for (let index = 0; index < linksHeader.length; index++) {
      const element = linksHeader[index];
      element.addEventListener('click', function(e) {
        e.preventDefault();
        var dataEvent = {
          "menu_level1": e.target.innerText
        };
        var evt = new CustomEvent("gtmLinksHeader", {'detail': dataEvent});
        window.dispatchEvent(evt);
        setTimeout(function(){location.href = element.getAttribute("href")}, 1000);
      });
    }
  }

  // FIX LOOX REVIEWS
  var looxRatings = document.querySelectorAll('.loox-rating-label');
  looxRatings.forEach(function (looxRating){
      var str = looxRating.innerHTML.replace('&nbsp;', '');
      looxRating.innerHTML = str;
  });

});

// PRODUCT CUSTOM SUBSCRIPTION

function updateCheckboxVisual() {

  const checkbox = document.getElementById('subscriptionCheck');
  const checkboxSubscription = document.querySelector('.custom-checkbox-subscription');
  const targetSellingPlan = document.querySelector('product-form input[name="selling_plan"]');
  const buttonSubscription = document.querySelector('.subscription-button');
  const mobilePrice = document.querySelector('.price-per-days--mobile');
  const mobileSubPrice = document.querySelector('.price-per-days--mobile-sub');
  const variantSelector = document.querySelector('variant-radios');
  
  if (targetSellingPlan) {
    if(checkbox.checked) {
      checkboxSubscription.style.backgroundColor = '#000';
      targetSellingPlan.setAttribute('value', variantSelector.getSellingPlan());
      buttonSubscription.style.border = '3px solid #ff7f87';
      if (mobilePrice) {
        mobilePrice.style.display = 'none';
      }
      if (mobileSubPrice) {
        mobileSubPrice.style.display = 'inline';
      }
    } else {
      checkboxSubscription.style.backgroundColor = '';
      buttonSubscription.style.border = '';
      targetSellingPlan.removeAttribute('value');
      if (mobileSubPrice) {
        mobileSubPrice.style.display = 'none';
      }
      if (mobilePrice) {
        mobilePrice.style.display = 'inline';
      }
    }
  }
}

const subscriptionCheck = document.getElementById('subscriptionCheck');
if (subscriptionCheck != null) {
  subscriptionCheck.addEventListener('change', updateCheckboxVisual);
}
